import { useRecoilValue } from 'recoil';

import { EmissionsDetailBreakdown } from '@/components/modules/emissions/detailed-breakdown';
import { EMISSIONS_DATA_SOURCES } from '@/lib/constants';
import { Co2Emission } from '@/lib/models/emissions/types';
import { ItineraryModel } from '@/lib/models/itinerary/types';
import { routesStatsState } from '@/state/routes';
import { SegmentModeType } from '@/types/api-types';
import { calcMinMaxPercent } from '@/utils/helpers/maths';

interface JourneyEmissionsProps {
  mode: SegmentModeType;
  emissions?: Co2Emission;
  itinerary: ItineraryModel;
}

const JourneyEmissions = ({ mode, emissions, itinerary }: JourneyEmissionsProps) => {
  const routeStatsOverview = useRecoilValue(routesStatsState);
  const comparison = routeStatsOverview?.emissions[mode];
  const percentage = comparison ? calcMinMaxPercent(emissions?.wtw || 0, comparison.max, comparison.min) : 50;

  if (!emissions?.wtw) return null;

  return (
    <div className="rounded-lg border border-grey-200 bg-white">
      <EmissionsDetailBreakdown
        mode={mode}
        value={emissions?.wtw}
        comparison={comparison}
        unit={emissions?.unit}
        wtwBreakdown={emissions}
        percentage={percentage}
        canOpenInCalculator
        source={{ type: EMISSIONS_DATA_SOURCES.ITINERARY, data: itinerary }}
      />
    </div>
  );
};

export { JourneyEmissions };
